import React from 'react';
import { FaHome, FaUser, FaBookOpen, FaProjectDiagram, FaCertificate, FaGripHorizontal } from 'react-icons/fa';
import { useState } from 'react';
import { Link } from 'react-scroll';
import classes from './NavBar.module.css';

export default function NavBar() {
  // const [showNavItem, setShowNavItem] = useState(false);
  // const toggleHandler = () => {
  //   setShowNavItem((prevstate) => !prevstate);
  // };
  // console.log(showNavItem);
  return (
    <div className={classes.navbar}>
      <nav className={classes.nav}>
        <Link to='home' spy={true} smooth={true} offset={-100} duration={500}>
          <h2 className={classes['nav-logo']}>
            Pank<span className={classes['logo-edit']}>aj</span>
          </h2>
        </Link>

        {/* <button onClick={toggleHandler} className={classes['nav-toggle']}>
          <FaGripHorizontal style={{ display: 'flex' }} />
        </button> */}

        <ul className={classes['nav-items']}>
          <li className={classes['nav-item']}>
            <FaHome style={{ fontSize: 20 }} />
            <Link to='home' spy={true} smooth={true} offset={-100} duration={500}>
              Home
            </Link>
          </li>
          <li className={classes['nav-item']}>
            <FaUser style={{ fontSize: 20 }} />
            <Link activeClass='active' to='about' spy={true} smooth={true} offset={-100} duration={500}>
              About
            </Link>
          </li>
          <li className={classes['nav-item']}>
            <FaBookOpen style={{ fontSize: 20 }} />
            <Link activeClass='active' to='skill' spy={true} smooth={true} offset={-100} duration={500}>
              Skills
            </Link>
          </li>
          <li className={classes['nav-item']}>
            <FaProjectDiagram style={{ fontSize: 20 }} />
            <Link activeClass='active' to='project' spy={true} smooth={true} offset={-100} duration={500}>
              Projects
            </Link>
          </li>
          <li className={classes['nav-item']}>
            <FaCertificate style={{ fontSize: 20 }} />
            <Link activeClass='active' to='certificate' spy={true} smooth={true} offset={50} duration={500}>
              Certificates
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}
